// @flow
import * as React from "react"
import _ from "lodash"
import {Link, withRouter} from "react-router-dom"
import * as Util from "../common"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {CardText} from "material-ui/Card"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import Button from "material-ui/RaisedButton"
import compose from "recompose/compose"
import withProps from "recompose/withProps"
import {containers} from "@swarm2/core"
import IncompleteIcon from "react-icons/lib/fa/circle"
import CompleteIcon from "react-icons/lib/fa/check-circle"

const M = Util.intlMessages("view.CombatForm")
const ZM = Util.intlMessages("zone")
const UM = Util.intlMessages("units")
const Description = Util.prefixedDescription("zone")

function SelectZoneItemIconRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {isCleared} = props
  // The style crap comes from how icons are styled when there's no connect()
  // wrapper. Wish the material-ui CSS tolerated wrappers; sigh.
  const Icon = isCleared ? CompleteIcon : IncompleteIcon
  return (
    <Icon
      width="1.6em"
      height="1.6em"
      style={{
        color: "rgb(117,117,117)",
        position: "absolute",
        margin: "0",
        top: "4px",
        left: "24px",
      }}
    />
  )
}
export const SelectZoneItemIcon = containers.combat.CombatFormSelectZoneItemIcon(
  SelectZoneItemIconRender,
)

function CombatSelectZoneRender(props) {
  const {zones, selectedZone, selectZone, charId} = props
  return (
    <SelectField
      floatingLabelText={<M id="zone" />}
      value={selectedZone}
      maxHeight={200}
      onChange={selectZone}
    >
      <MenuItem key={null} value={null} primaryText="" />
      {zones.map(zone => (
        <MenuItem
          key={zone}
          value={zone}
          leftIcon={<SelectZoneItemIcon zone={zone} charId={charId} />}
          primaryText={<ZM id={zone} />}
        />
      ))}
    </SelectField>
    //leftIcon={<CompleteIcon />}
    //leftIcon={<ZoneMenuItemIcon zone={zone} charId={charId} />}
  )
}
const CombatSelectZone = compose(
  withProps(props => ({
    selectZone: (event, index, value) => props.setSelectedZone(value),
  })),
  //injectIntl,
)(CombatSelectZoneRender)

function YourArmySoldierItemRender(props) {
  const {charId, readonly, soldierName, count, error} = props
  if (error) return "..."
  const url = (readonly ? "/c/" : "/p/") + charId + "/units"
  return (
    <li>
      <Link to={url + "/" + soldierName}>
        <Util.Num val={count} />{" "}
        <UM id={soldierName + ".plural"} values={{count}} />
      </Link>
    </li>
  )
}
const YourArmySoldierItem = containers.combat.CombatFormYourArmySoldierItem(
  YourArmySoldierItemRender,
)
function YourArmy(props) {
  const {readonly, charId, soldierNames} = props
  return (
    <div>
      <h4>
        <M id="yourarmy" />
      </h4>
      {soldierNames.map(soldierName => (
        <YourArmySoldierItem
          key={soldierName}
          charId={charId}
          soldierName={soldierName}
          readonly={readonly}
        />
      ))}
    </div>
  )
}
function SelectedZoneSoldierItemRender(props) {
  const {soldierName, count, error} = props
  if (error) return "..."
  return (
    <li>
      <Util.Num val={count} />{" "}
      <UM id={soldierName + ".plural"} values={{count}} />
    </li>
  )
}
const SelectedZoneSoldierItem = containers.combat.CombatFormSelectedZoneSoldierItem(
  SelectedZoneSoldierItemRender,
)
function CombatFormSelectedZoneRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {charId, zone, isCleared, soldierNames, grindCount, isGrind} = props
  return (
    <div>
      <p>
        <Description id={zone} />
      </p>
      <ul>
        {soldierNames.map(soldierName => (
          <SelectedZoneSoldierItem
            key={soldierName}
            charId={charId}
            zone={zone}
            soldierName={soldierName}
          />
        ))}
      </ul>
      {isCleared ? (
        <Util.Tooltip id="view.CombatForm.grinding.lol">
          {isGrind ? (
            <M
              id="grinding"
              values={{
                grindCount: grindCount.floor().toNumber(),
                grindCountText: <Util.Num val={grindCount} />,
              }}
            />
          ) : (
            <M id="nogrind" />
          )}
        </Util.Tooltip>
      ) : null}
    </div>
  )
}
const CombatFormSelectedZone = containers.combat.CombatFormSelectedZone(
  CombatFormSelectedZoneRender,
)

function CombatFormRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    readonly,
    charId,
    onSubmit,
    isSubmittable,
    soldierNames,
    request,
    zoneClears,
    isRunning,
    nextUrl,
    hatcheryProdBonus,
    isZoneSelectVisible,
  } = props
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" />} />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <M
          id="expansion"
          values={{
            zoneClearText: <Util.Num val={zoneClears} />,
            zoneClears,
            hatcheryProdBonus: (
              <Util.Percent minusone val={hatcheryProdBonus} />
            ),
          }}
        />
        <YourArmy
          charId={charId}
          soldierNames={soldierNames}
          readonly={readonly}
        />
        {isZoneSelectVisible ? (
          <div>
            <CombatSelectZone
              {..._.pick(
                props,
                "zones",
                "selectedZone",
                "setSelectedZone",
                "charId",
              )}
            />
            {props.selectedZone ? (
              <CombatFormSelectedZone
                zone={props.selectedZone}
                charId={charId}
              />
            ) : null}
            {readonly ? null : (
              <div>
                <Button
                  primary
                  disabled={!isSubmittable || isRunning}
                  onClick={onSubmit}
                  label={<M id="submit" />}
                />
              </div>
            )}
          </div>
        ) : (
          <M id="nounits" />
        )}
        {request.status === "pending" ? (
          <div>
            <Util.LoadingSpinner />
          </div>
        ) : null}
        {!request.status && isRunning ? (
          <p>
            <Link to={nextUrl}>You're already in combat!</Link>
          </p>
        ) : null}
      </CardText>
    </div>
  )
}
export default compose(
  containers.combat.CombatForm,
  withRouter,
  withProps(
    props => !props.error && {nextUrl: "/p/" + props.charId + "/combat/run"},
  ),
  containers.willReceiveProps(props => {
    if (props.request && props.request.status === "success") {
      props.history.push(props.nextUrl)
    }
  }),
  Util.DumpProps,
)(CombatFormRender)



// WEBPACK FOOTER //
// ./src/combat/CombatForm.js